import { useState } from 'react';
import JourneySelector from './cycle/JourneySelector';
import MenstrualTracker from './cycle/MenstrualTracker';
import PerimenopauseTracker from './cycle/PerimenopauseTracker';
import MenopauseTracker from './cycle/MenopauseTracker';
import PregnancyPostpartumTracker from './PregnancyPostpartumTracker';
import IVFTracker from './cycle/IVFTracker';

type Journey = 'menstrual' | 'perimenopause' | 'menopause' | 'pregnancy' | 'postpartum' | 'ivf' | null;

export default function CycleAndLunarHub() {
  const [selectedJourney, setSelectedJourney] = useState<Journey>(null);

  const handleJourneyChange = (journey: 'menstrual' | 'pregnancy' | 'perimenopause' | 'menopause' | 'postpartum' | 'ivf') => {
    setSelectedJourney(journey);
  };

  // Always show journey selector first - no auto-loading
  if (!selectedJourney) {
    return <JourneySelector onSelectJourney={setSelectedJourney} />;
  }

  const handleBack = () => {
    setSelectedJourney(null);
  };

  switch (selectedJourney) {
    case 'menstrual':
      return <MenstrualTracker onBack={handleBack} onJourneyChange={handleJourneyChange} />;
    case 'perimenopause':
      return <PerimenopauseTracker onBack={handleBack} onJourneyChange={handleJourneyChange} />;
    case 'menopause':
      return <MenopauseTracker onBack={handleBack} />;
    case 'ivf':
      return <IVFTracker onBack={handleBack} />;
    case 'pregnancy':
    case 'postpartum':
      return <PregnancyPostpartumTracker onBack={handleBack} />;
    default:
      return <JourneySelector onSelectJourney={setSelectedJourney} />;
  }
}
